import * as React from 'react';
import {ManagerIconGradient} from "components/widgets/icons/ManagerIcon";
import {API} from "api";
import {useState} from "react";
import {UIState} from "data/UIState";

import './PlatformAdminNotification.pcss';

export const PlatformAdminNotification = () => {

  const [ gotItClicked, setGotItClicked ] = useState(false);

  if(!UIState.user.isClientContact || UIState.user.clientContactAccessAckDate) {
    return null;
  }

  function gotIt() {
    if(!gotItClicked) {
      setGotItClicked(true);
      API.get("/cmd/user/ackClientContactAccess")
        .then(() => {
          UIState.user.clientContactAccessAckDate = new Date();
          setGotItClicked(false);
        })
        .catch((err) => {
          console.log(err);
          UIState.user.clientContactAccessAckDate = new Date();
          setGotItClicked(false);
        });
    }
  }

  return (
    <div className={"platform-admin-notification"}>
      <div><ManagerIconGradient /></div>
      <div>
        <h2>You have Platform Admin permissions</h2>
        <p>Your account allows you to generate on demand reports and send email invites.</p>
      </div>
      <div><button aria-label={"Got it. Dismiss this notification"} onClick={gotIt}><span aria-hidden>GOT&nbsp;IT</span></button> </div>
    </div>
  );

}

